export default "__VITE_ASSET__95f855d7__"